import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useState } from "react";
import { earlyWarning, openEwsWindowsMap } from "../mainLayer/earlyWarning/ShowEarlyWarning";

interface EwsSidebar {
  sensorId: string | null;
  coordinates: Coordinate | null;
  adm4_en: string | null;
  active_pcode: string | null;
  end_time: string | null;
  s_desc: string | null;
  severity_index: string | null;
  severity: string | null;
  adm4_pcode: string | null;
  adm3_pcode: string | null;
  adm3_en: string | null;
  adm2_pcode: string | null;
  adm2_en: string | null;
  active_alevel: string | null;
  en_desc: string | null;
  validityPeriod: string | null;
  issued_time: string | null;
  w_status: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
  adm1_en: string | null;
}

// Define the context type
type EWSContextType = {
  EWSOpenSidebarMap: Map<string, EwsSidebar>;
  setEWSOpenSidebarMap: (type: string, ewsopenMap: EwsSidebar) => void;
  removeFromEWSOpenSidebarMap: (active_pcode: string) => void;
  clearEWSOpenSidebarMap: () => void;
  clickedString: string | null;
  setClickedString: (value: string) => void;
  earlyWarningsFull: earlyWarning[];  // Adjust type based on your data structure
  setEarlyWarningsFull: (data: earlyWarning[]) => void;
};

// Create the context
const EWSContext = createContext<EWSContextType | undefined>(undefined);

// Define the provider component
export const EWSProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize EWSOpenSidebarMap in state
  const [EWSOpenSidebarMap, setEWSOpenSidebarMapState] = useState(new Map<string, EwsSidebar>());
  const [clickedString, setClickedString] = useState<string | null>(null);
  const [earlyWarningsFull, setEarlyWarningsFull] = useState<earlyWarning[]>([]);
  const [enableTest, setEnableTest] = useState<boolean>(false);


  // Function to add or update an entry in EWSOpenSidebarMap
  const setEWSOpenSidebarMap = (type: string, ewsopenMap: EwsSidebar) => {
    setEWSOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(type, ewsopenMap);
      return newMap;
    });
  };

  // Function to remove an entry by active_pcode
  const removeFromEWSOpenSidebarMap = (active_pcode: string) => {

    setEWSOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(active_pcode);
      return newMap;
    });
  };

    const clearEWSOpenSidebarMap = () => {
        setEWSOpenSidebarMapState(new Map());
      };



  // Provide the state and the updater functions
  return (
    <EWSContext.Provider value={{ EWSOpenSidebarMap, setEWSOpenSidebarMap, removeFromEWSOpenSidebarMap,clearEWSOpenSidebarMap, clickedString, setClickedString ,earlyWarningsFull,setEarlyWarningsFull}}>
      {children}
    </EWSContext.Provider>
  );
};

// Custom hook for using EWSContext
export const useEWSContext = () => {
  const context = useContext(EWSContext);
  if (!context) {
    throw new Error("useEWSContext must be used within an EWSProvider");
  }
  return context;
};
